import React from 'react';
import { withTheme } from 'styled-components';
export var PlaceholderIcon = function PlaceholderIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: "#F0F6FF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6669 15.0065C58.6143 14.9933 60.4863 15.7586 61.8667 17.1322L60.985 18.0183L61.8705 17.136C63.2453 18.5158 64.0113 20.3879 63.9981 22.3356C63.9848 24.2808 63.1955 26.14 61.8055 27.5006L37.7021 51.5973C37.5453 51.754 37.3497 51.8663 37.1352 51.9225L25.5652 54.9541C25.1356 55.0667 24.6784 54.9428 24.3644 54.6287C24.0504 54.3146 23.9266 53.8575 24.0393 53.4279L27.0726 41.8612C27.1288 41.6467 27.2411 41.451 27.3979 41.2943L51.5015 17.1973C52.8628 15.8083 54.7219 15.0197 56.6669 15.0065ZM60.1017 18.9027C59.194 18.0004 57.9637 17.4978 56.6839 17.5065C55.4032 17.5152 54.1791 18.0351 53.2837 18.9506L53.2738 18.9607L29.4049 42.8229L26.9999 51.9938L36.174 49.5899L60.0532 25.7173C60.9691 24.8227 61.4894 23.599 61.4981 22.3186C61.5068 21.0393 61.004 19.8095 60.1017 18.9027Z",
    fill: theme.colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8177 17.8829C51.3057 17.3946 52.0972 17.3945 52.5854 17.8825L61.1221 26.4159C61.6103 26.9039 61.6105 27.6954 61.1224 28.1836C60.6344 28.6719 59.8429 28.6721 59.3547 28.184L50.818 19.6507C50.3298 19.1626 50.3296 18.3711 50.8177 17.8829Z",
    fill: theme.colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3343 21.3629C47.8224 20.8746 48.6138 20.8745 49.1021 21.3625L57.6387 29.8959C58.127 30.3839 58.1271 31.1754 57.6391 31.6636C57.151 32.1519 56.3596 32.152 55.8713 31.664L47.3346 23.1306C46.8464 22.6426 46.8462 21.8511 47.3343 21.3629Z",
    fill: theme.colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.132 41.6877C27.403 41.0527 28.1374 40.7576 28.7723 41.0286L34.7556 43.5819C35.0515 43.7082 35.2873 43.9436 35.414 44.2392L37.974 50.2126C38.2459 50.8471 37.952 51.582 37.3174 51.8539C36.6829 52.1258 35.948 51.8319 35.6761 51.1974L33.3135 45.6846L27.7911 43.328C27.1561 43.057 26.861 42.3226 27.132 41.6877Z",
    fill: theme.colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3706 25.6294C53.8587 26.1176 53.8586 26.9091 53.3704 27.3972L35.1487 45.6139C34.6605 46.1019 33.869 46.1018 33.3809 45.6136C32.8929 45.1254 32.893 44.3339 33.3812 43.8458L51.6029 25.6292C52.0911 25.1411 52.8825 25.1412 53.3706 25.6294Z",
    fill: theme.colors.primary
  }));
};
export var PlaceholderQuestionsIcon = withTheme(PlaceholderIcon);